import React from "react";
import "./Feedback.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { Form } from "react-bootstrap";

function Feedback() {
  return (
    <>
      <section className="Feedback">
        <Common_white_header headingText={"Feedback"} />
        <div className="container">
          {/* Invite Code */}
          <div className="form-group field_holder ">
            <Form.Group className="mb-3">
              <Form.Control
                as="textarea"
                rows={5}
                type="text"
                placeholder="Welcome to feedback, please give feedback-please describe the problem in detail when providing feedback, preferably attach a screenshot of the problem you encountered, we will immediately process your feedback!"
              />
            </Form.Group>
          </div>


          <div className="note_text_Holder">
            <p>Send Helpful Feedback Chance To Win Mystery Rewards</p>
            <div className="img_holder">
                <img className="sticker_img" src="/assets/images/Feedback/Feedback_sticker.png" alt="sticker"/>
            </div>
          </div>
          <button class="btn_register_bg my-5">Submit</button>
        </div>
      </section>
    </>
  );
}

export default Feedback;
